var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilSimpleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 20.25H4.5C4.30109 20.25 4.11033 20.171 3.96967 20.0304C3.82902 19.8897 3.75 19.699 3.75 19.5V15.3094C3.74966 15.212 3.76853 15.1155 3.80553 15.0254C3.84253 14.9354 3.89694 14.8534 3.96563 14.7844L15.2156 3.53441C15.2854 3.46355 15.3686 3.40728 15.4603 3.36886C15.5521 3.33045 15.6505 3.31067 15.75 3.31067C15.8495 3.31067 15.9479 3.33045 16.0397 3.36886C16.1314 3.40728 16.2146 3.46355 16.2844 3.53441L20.4656 7.71567C20.5365 7.78545 20.5928 7.86864 20.6312 7.96038C20.6696 8.05212 20.6894 8.15058 20.6894 8.25004C20.6894 8.3495 20.6696 8.44796 20.6312 8.5397C20.5928 8.63144 20.5365 8.71463 20.4656 8.78441L9.00001 20.25Z",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.25H9",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6L18 11.25",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSimpleLine);
export default __webpack_public_path__ + "static/media/PencilSimpleLine.c174e7d6bca4632fa4c4f5ba0b0d563b.svg";
export { ForwardRef as ReactComponent };